<script>

    import { createEventDispatcher } from 'svelte';

    import { timer } from './gameState.js';
    import { endurance_start_time } from './gameState.js';
    import { timer_started} from './gameState.js';
    import { is_game_over} from './gameState.js';

    const dispatch = createEventDispatcher();

    var intervalID = window.setInterval(eachSecond, 1000);

    //Sets initial timer value.
    timer.update((n) => $endurance_start_time);

    function eachSecond(){
        //console.log(timer);
        if($timer > 0 && !$is_game_over && $timer_started) {
            timer.update((n) => n - 1);
            if($timer <= 0) {
                timeEnded();
            }
        }
    }

    function timeEnded() {
        dispatch('timerended', {});
    }
</script>

<div><span>{$timer}</span></div>

<style>
    div {
        position: absolute;
        left: 0; 
        right: 0; 
        margin-left: auto; 
        margin-right: auto; 
        width: 100px; /* Need a specific value to work */
        text-align: center;
        background-color: rgba(200,200,200,0.8);
        border-radius: 0px 0px 10px 10px;

    }

    span {
        font-size: 44px;
        font-weight: bold;
    }
</style>